import { Identifiable, Project, projectSynthesis } from "@planzone/dto";
import { Selector, State } from "./types";

function get(getState: () => State, { uuid }: Identifiable<Project>) {
  return getState().find((res) => res.project.uuid === uuid);
}

function queryState(getState: () => State, project: Identifiable<Project>) {
  return <Result>(
    query: (res: State[number]) => Result,
    fallBack: Result,
  ): Result => {
    const state = get(getState, project);

    return state ? query(state) : fallBack;
  };
}

function createSelector(getState: () => State): Selector {
  return {
    isProjectSynthesisRetrievalRequestFailure(project) {
      return queryState(getState, project)(
        (res) => res.request.isFailure,
        false,
      );
    },
    isProjectSynthesisRetrievalRequestPending(project) {
      return queryState(getState, project)(
        (res) => res.request.isPending,
        false,
      );
    },
    isProjectSynthesisRetrievalRequestSuccess(project) {
      return queryState(getState, project)(
        (res) => res.request.isSuccessful,
        false,
      );
    },
    getProjectSynthesis(project) {
      return queryState(getState, project)(
        (res) => res.synthesis,
        projectSynthesis,
      );
    },
  };
}

export { createSelector };
